import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { AppDispatch, IReduxState } from 'store/types';

export const useAppSelector: TypedUseSelectorHook<IReduxState> = useSelector;
export const useAppDispatch: () => AppDispatch = useDispatch;
